import React from 'react';

import {
  Alert,
  Grid,
} from '@mui/material';

import { Exam } from '../../../services/exams/types';
import { Metadata } from '../../../services/types';

import ActionsCard from './ActionsCard';
import ExamDetailsCard from './ExamDetailsCard';

interface DetailsTabProps {
  exam?: Exam,
  examMetadata?: Metadata
}

const DetailsTab = ({ exam, examMetadata }: DetailsTabProps) => (
  <Grid container spacing={2}>
    {exam?.active === false && (
      <Grid item xs={12}>
        <Alert severity="warning">
          This exam is currently inactive.
          The exam needs to be active before it can be marked by Teachers.
          The exam active/inactive state can be altered in the Settings Tab.
        </Alert>
      </Grid>
    )}
    <Grid item xs={12}>
      <ExamDetailsCard exam={exam} examMetadata={examMetadata} />
    </Grid>
    <Grid item xs={12}>
      <ActionsCard exam={exam} />
    </Grid>
  </Grid>
);

export default DetailsTab;
